module.exports = __webpack_public_path__ + "startpage-746fed5a/template-7-2x-0fa063e00a1cbd689dcd24133b083cb5.jpg";